/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React from 'react'
import * as Icon from 'react-feather'

const navigationConfig = [
  {
    id: 'home',
    title: 'Dashboard',
    type: 'item',
    icon: <Icon.Home size={20} />,
    navLink: '/',
  },
  {
    id: 'notification',
    title: 'Notification',
    type: 'item',
    icon: <Icon.Bell size={20} />,
    navLink: '/notification',
  },
  {
    id: ' group notification',
    title: ' Group Notification',
    type: 'item',
    icon: <Icon.Bell size={20} />,
    navLink: '/vendorNotificationGroup/list',
  },
  {
    id: 'plan',
    title: 'Plan',
    type: 'item',
    icon: <Icon.Phone size={20} />,
    navLink: '/plan-list',
  },

  {
    id: 'category',
    title: 'Category',
    type: 'item',
    icon: <Icon.List size={20} />,
    navLink: '/category/list',
  },
  {
    id: 'circles',
    title: 'Circle',
    type: 'item',
    icon: <Icon.Circle size={20} />,
    navLink: '/circle/list',
  },
  {
    id: 'countries',
    title: 'Country',
    type: 'item',
    icon: <Icon.Globe size={20} />,
    navLink: '/country/list',
  },
  {
    id: 'operators',
    title: 'Operator',
    type: 'item',
    icon: <Icon.BarChart size={20} />,
    navLink: '/operator/list',
  },
  {
    id: 'validityUnit',
    title: 'Validity Unit',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/validity-unit/list',
  },
  {
    id: 'tag',
    title: ' Tag',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/tag/list',
  },
  {
    id: 'subscription',
    title: ' Subscription',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/subscription/list',
  },
  {
    id: 'batchTask',
    title: ' Batch',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/batchTask/list',
  },
  {
    id: 'talktimeUnit',
    title: 'Talktime Unit',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/talktime-unit/list',
  },
  {
    id: 'dataUnit',
    title: 'Data Unit',
    type: 'item',
    icon: <Icon.Database size={20} />,
    navLink: '/data-unit/list',
  },
  {
    id: 'smsUnit',
    title: 'SMS Unit',
    type: 'item',
    icon: <Icon.MessageSquare size={20} />,
    navLink: '/sms-unit/list',
  },
  {
    id: 'callsUnit',
    title: 'Call Unit',
    type: 'item',
    icon: <Icon.PhoneCall size={20} />,
    navLink: '/calls-unit/list',
  },
  {
    id: 'vendor',
    title: 'Vendor',
    type: 'item',
    icon: <Icon.Package size={20} />,

    navLink: '/vendor/list',
  },
  {
    id: 'vendorPlan',
    title: 'Vendor Plan',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/vendor-plan/list',
  },
  {
    id: 'vendorDefinition',
    title: 'Vendor Definition',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/vendor-definition/list',
  },
  {
    id: 'superAdmin',
    title: 'Super Admin ',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/superAdmin/read-all-vendor-notification',
  },

  {
    id: 'staff',
    title: 'Staff',
    type: 'item',
    icon: <Icon.User size={20} />,
    // permissions: ['Admin'],
    navLink: '/staff/list',
  },
  {
    id: 'utility',
    title: 'Utility',
    type: 'collapse',
    icon: <Icon.HardDrive size={20} />,
    // permissions: ['admin'],
    children: [
      {
        id: 'setting',
        title: 'Setting',
        type: 'item',
        icon: <Icon.Settings size={20} />,
        // permissions: ['admin'],
        navLink: '/setting/list',
      },
    ],
  },

  {
    id: 'logout',
    title: 'Log Out',
    type: 'item',
    icon: <Icon.LogOut size={20} />,
    navLink: '/logout',
  },
]

export default navigationConfig
